import React from 'react'
import MainPage from '../../composents/MainPage'
import DataTable from '../../composents/DataTable'
import resources from '../../services'

const title = 'Settings'
const headers = {
  icon: 'feather icon-box',
  title,
  description: 'track and manage all settings information',
}

function SettingPage() {
  return (
    <MainPage headers={headers} show_search>
      <DataTable
        column={[
          {
            label: 'Name',
            field: 'name',
          },
          {
            label: 'Value',
            field: 'value',
          },
        ]}
        resource={resources.setting}
        title={title}
        link="/settings"
        deleteItem={false}
        show_btn={false}
      />
    </MainPage>
  )
}

export default SettingPage
